import { PageWrapper } from 'components';
import React from 'react';

export const UserProfile = (): React.JSX.Element => {
    /**
     * Leaving empty page component for now until the UX design is ready.
     */
    return <PageWrapper title='User Profile' />;
};
